import instance from '@apis/instance';
import { PresignedUrlRequest, PresignedUrlResponse } from '@models/file';

class FileApi {
  static issuePresignedUrl(request: PresignedUrlRequest): Promise<PresignedUrlResponse> {
    return instance.post('/image', request);
  }
}

export default FileApi;
